import $ from "jquery";

// Find external domains or pdf's and set rel="external" on the link.
const initExternalLinks = function () {
  $('a[href^=http]:not([rel~="external"])').each(function () {
    if (
      this.href.indexOf(window.location.hostname) === -1 ||
      this.href.indexOf(`.${window.location.hostname}`) !== -1
    ) {
      $(this).attr("rel", "external");
    }
  });
  $("a[href$=pdf]").each(function () {
    $(this).attr("rel", "external");
  });
  $("a[href$=png], a[href$=jpg], a[href$=jpeg], a[href$=gif]").each(
    function () {
      $(this).attr("rel", "external");
    },
  );
};

// Find mailto links and open in a new window.
const initMailtoLinks = function () {
  $(
    'a[href^="mailto:"]:not(.c-link--external-ignore):not(.c-link--apply-now)',
  ).each(function () {
    if (this.href.indexOf("mailto:") === 0) {
      $(this).attr({ rel: "external", "data-js": "jsEmailModalTrigger" });

      $(this).html(function (_, email) {
        return email.replace(/([@.])/g, "<wbr>$1");
      });
    }
  });
};

const initRelAttributes = function () {
  $('a[rel~="external"]:not(a[rel~="noopener"])').attr(
    "rel",
    "external noopener",
  );
  $('a[rel~="noopener"]:not(a[rel~="external"])').attr(
    "rel",
    "external noopener",
  );
};

const initTargetBlank = function () {
  $('a[rel~="external"]').attr("target", "_blank");
};

const initHiddenText = function () {
  $('a[rel~="external"]')
    .filter(function () {
      return !$(this).children().is(".external-text");
    })
    .append(
      '<span class="h-visually-hidden external-text">Opens in new window</span>',
    );
};

const initExternalIcon = function () {
  /**
   * Add external icons to all external links except the following:
   * - Social Icons
   * - Buttons
   * - Mailto
   */

  $(
    'a[rel~="external"]:not(a[href^="mailto:"]):not(.c-link--external-ignore):not(.c-page-tertiary__social a):not(.media a):not(.c-button--1):not(c-button--2)',
  )
    .filter(function () {
      return $("img", this).length === 0;
    })
    .append(
      '<span class="c-icon--external">' +
        '<svg class="c-svg-sprite c-svg-sprite--external" height="13" width="13">' +
        '<use xlink:href="/themes/custom/duchess/dist/svg-sprite/svg-sprite.svg#external"></use>' +
        "</svg>" +
        "</span>",
    );
};

// PUBLIC
const init = function () {
  initExternalLinks();
  initMailtoLinks();
  initRelAttributes();
  initTargetBlank();
  initHiddenText();
  initExternalIcon();
  document.body.classList.add("links-init");
};

if (window.Drupal) {
  window.Drupal.behaviors.links = {
    attach() {
      if ($(".links-init").length === 0) {
        init();
      }
    },
  };
} else {
  $(function () {
    if ($(".links-init").length === 0) {
      init();
    }
  });
}

$(document).on("storybook:component:change", function () {
  if ($(".links-init").length === 0) {
    init();
  }
});
